import { useContext, useEffect } from "react";
import { observer } from "mobx-react";
import { UserStore } from "..";
import { useLocation, useNavigate } from "react-router";
import { PageContainer } from "../components/page";
import { returnPathFrom } from "./util";

const SelectVenuePage = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const userStore = useContext(UserStore);
  const returnPath = returnPathFrom(location.state);
  const selectVenue = (venue: any) => {
    userStore.changeVenueWithLoading(venue);
    userStore.venueSearchTerm = "";
    navigate(returnPath);
  };

  const updateSearchTerm = (venueSearchTerm: string) => {
    userStore.venueSearchTerm = venueSearchTerm;
  };

  const { selectedVenue, userVenues, userVenuesAlphabetical, venueSearchTerm } =
    userStore;

  useEffect(() => {
    if (!userStore.isLoggedIn) {
      navigate("/login");
    }
    if (userStore.selectedVenue) {
      navigate(returnPath);
    }
  }, []);

  return (
    <PageContainer>
      <section className="bg-white dark:bg-gray-900">
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6 ">
          <div className="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
            <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
              Select a venue
            </h2>
          </div>

          {userVenues && userVenues.length > 8 && (
            <div className="my-5 w-full flex justify-center">
              <input
                value={venueSearchTerm}
                onChange={(event) =>
                  updateSearchTerm(event.target.value.toLowerCase())
                }
                type="text"
                id="input-group-search"
                className="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Search Venue"
              />
            </div>
          )}

          <div className="grid gap-8 mb-6 lg:mb-16 md:grid-cols-2">
            {userVenuesAlphabetical?.map((venue) => (
              <div
                key={venue.venueId}
                onClick={() => selectVenue(venue)}
                className="cursor-pointer items-center bg-gray-50 rounded-lg shadow hover:bg-slate-200 transition-all min-h-20 min-w-20 flex gap-2 p-3"
              >
                <div className="w-20 h-20 rounded-xl bg-gray-200">
                  <img
                    className="w-20 h-20 rounded-xl object-cover"
                    src={venue.iconUrl}
                    alt={""}
                    loading="lazy"
                    onError={(e: any) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </div>
                <h3 className="text-xl font-bold tracking-tight text-gray-900 dark:text-white">
                  {venue.displayName}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageContainer>
  );
});

export default SelectVenuePage;
